import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
// import Header from "../components/container/layout/client/Header";
import BusinessHeader from "../components/container/layout/business/Header";
import BusinessUserHeader from "../components/container/layout/business_user/Header";
// import BusinessUserSideBar from "../components/container/SideBar";
// import ClientSideBar from "../components/container/layout/client/SideBar";
// import FooterSection from "../components/UI/FooterSection";
import Footerad from '../components/UI/Footerad';
import axios from "axios";
import { CONFIG } from "../config/data";

import { getTimeoutbycategory } from "../config/url.json";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';

import Headerweb from './Headerweb';
import FooterWeb from './Footerweb';
import Topmove from './Topmove';
import { Helmet } from 'react-helmet';

function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch({ type: "SET_LOGOUT" }),
    };
}


class PatientManagment extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef()
        const hospitaltimeout = this.state;
        this.state = {
            timeout: hospitaltimeout,
            isTimedOut: false,
            showModal: false,
        }
        this.idleTimer = null
        this.onAction = this._onAction.bind(this)
        this.onActive = this._onActive.bind(this)
        this.onIdle = this._onIdle.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleLogout = this.handleLogout.bind(this)

    };
    handleClose() {
        this.setState({ showModal: false })
    }


    handleLogout = (e) => {
        this.setState({ showModal: false })
        e.preventDefault();
        localStorage.removeItem("token");
        this.props.logout();

    };

    _onAction(e) {
        console.log('user did something', e)

        this.setState({ isTimedOut: false })
    }

    _onActive(e) {

        console.log('user is active', e)
        this.setState({ isTimedOut: false })
    }

    _onIdle = (e) => {
        console.log('user is idle', e)
        let isTimedOut = this.state.isTimedOut
        let timeout = this.state.timeout;
        console.log(timeout);
        console.log(isTimedOut);
        if (isTimedOut===false) 
        {
         // console.log("the time is over");
          this.setState({showModal: true})
          console.log(this.state.showModal);
           this.idleTimer.reset();
           this.setState({isTimedOut: true})
    
        } 
       if(isTimedOut===true)
       {
        localStorage.removeItem("token");
        this.props.logout();
      }
    }

    render() {
        const { hospitaltimeout } = this.state;
        return (
            <div className="">
              <Helmet>
                    <title>Patient Management System & Digital EMR Software | KlinicQ</title>
                    <meta 
                        name="description" 
                        content="Digitize patient records, appointments, and communication with KlinicQ’s patient management software. Improve patient experience with secure, cloud-based EMR." 
                    />
                </Helmet>

                <div className="">
                    {/* <section className="my-head"> */}
                        {/* <div className="container-fluid">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessHeader user_id={this.props.userdata.id} />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserHeader user_id={this.props.userdata.id} />
                            ) : (
                                <Header user_id={this.props.userdata.id} />
                            )}
                        </div> */}
                    {/* </section> */}
                    <div className="">
                        {/* <div className="sidemenu ">
                            {this.props.userdata.user_type.toLowerCase() === "hospital" ? (
                                <BusinessUserSideBar />
                            ) : this.props.userdata.user_type.toLowerCase() === "doctor" ? (
                                <BusinessUserSideBar />
                            ) : (
                                <ClientSideBar />
                            )}
                        </div> */}

                        {/* <section className="main-body hospital-profilegap "> */}
                            {/* <IdleTimeOutModal
                                showModal={this.state.showModal}
                                handleClose={this.handleClose}
                                handleLogout={this.handleLogout}
                            /> */}

                            {/* <IdleTimer
                                ref={ref => { this.idleTimer = ref }}
                                element={document}
                                onActive={this.onActive}
                                onIdle={this.onIdle}
                                onAction={this.onAction}
                                debounce={250}
                                timeout={hospitaltimeout} /> */}

                            {/* <div className="container-fluid checkout-tabs"> */}
                                {/* <IdleTimeOutModal
                                    showModal={this.state.showModal}
                                    handleClose={this.handleClose}
                                    handleLogout={this.handleLogout}
                                /> */}

                                {/* <IdleTimer
                                    ref={ref => { this.idleTimer = ref }}
                                    element={document}
                                    onActive={this.onActive}
                                    onIdle={this.onIdle}
                                    onAction={this.onAction}
                                    debounce={250}
                                    timeout={hospitaltimeout} /> */}

<div className='product-section'>
    <Headerweb/>
  
    
 
            <hr className='m-0' style={{ color: '#D9F4FF' }} />
 <section id="pharma-hero-section">
  <div className="pharma-hero-background">
    <div className="patientmang-hero-gradient"></div>
    <img
      src={require("../../src/assets/images/website/pharma1.png")}
      alt="Pharmacists assisting a customer"
      className="pharma-hero-bg-image"
    />
  </div>
  <div className="pharma-container pharma-hero-content-container">
    <div className="pharma-hero-text">
      <h1>Patient Management System</h1>
      <p>
       The Patient Management module simplifies the entire lifecycle of patient care—from registration and appointment booking to medical history tracking and discharge summaries. Designed for speed and clarity, it ensures that healthcare staff can access and update patient records with minimal clicks and maximum accuracy.
      </p>
    </div>
   
  </div>
</section>

    <section id="hospitalmang-feature-one">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/patmang1.png")} alt="Doctor using a futuristic medical interface." />
      </div>
     <div class="hospitalmang-feature-text-wrapper">
  <p>
    The patient portal is designed to manage primary and family members under the same account with unique ID for each member. Patients can access their health history, medical records, and discharge summary and communicate with doctors and hospitals anytime & anywhere. Patients' Personal Identification Information (PII) and Patient Health Information (PHI) is encrypted as per HIPAA guidelines for data privacy & security.
  </p>
  <p>
    KlinicQ application's Patient module allows booking, rescheduling, or canceling appointments through mobile apps to reduce no-shows. If a patient is running late, the system automatically provides grace time and adjusts the schedule to avoid long waiting room delays.
  </p>
  <p>
    Patients can search hospitals or clinics in our network based on various filters like doctor specialty, hospital name, gender, city, and distance from their location. The KlinicQ application is integrated with Google Maps to show live waiting time data for nearby hospitals and update users with travel distance to the healthcare provider's location.
  </p>
  <p>
    For pregnant women, children, physically challenged, and elderly patients, waiting in crowded rooms can be distressing and risky. More crowds in the waiting room cause mental trauma and increase the risk of airborne diseases. KlinicQ's Token Management System algorithm allocates appointment times for each token, allowing visitors to arrive just before their scheduled time. This minimizes waiting room congestion, promotes social distancing, and helps reduce the spread of airborne illnesses.
  </p>
</div>

    </div>
  </div>
</section>

<section id="hospitalmang-feature-two">
  <div class="hospitalmang-main-container">
    <div class="hospitalmang-feature-block">
      <div class="hospitalmang-feature-text-wrapper">
  <p>
    The KlinicQ application is user-friendly, easy to navigate, and allows patients to check doctor availability with accurate wait times. It ensures data security and confidentiality, sending appointment confirmations and follow-up notifications to reduce no-shows.
  </p>
  <p>
    KlinicQ also supports online consultations via video calling, enabling patients who cannot visit the hospital or clinic to connect with available doctors remotely. Patients can mark their favorite healthcare providers for quicker appointment booking.
  </p>
  <p>
    Medical records such as prescriptions, discharge summaries, and vital details from previous consultations can be scanned or uploaded as images. This digital access helps doctors review complete patient history for more effective treatment.
  </p>
  <p>
    Additional features include general health tips, BMI tracking, and vital statistics. The application supports online payments through a secure gateway, QR code-based touchless check-in, and is available on both iOS and Android platforms.
  </p>
  <p>
  The application also includes a built-in notification center that alerts users about upcoming health camps, vaccination drives, and seasonal health advisories. This proactive engagement helps patients stay informed and encourages preventive care.
</p>

  <p>
    KlinicQ offers multilingual support with five language options: English, Tamil, Hindi, Telugu, and Kannada, making healthcare access more inclusive and convenient for diverse users.
  </p>
</div>

      <div class="hospitalmang-feature-image-wrapper">
        <img src={require("../../src/assets/images/website/patmang2.png")} alt="Medical professionals discussing a patient's case." />
      </div>
    </div>
  </div>
</section>

 <div className='single-click py-5'>
          <div className='container'>
            <div className='row m-0'>
              {/* <div className='col-lg-4 col-12 mb-lg-0 mb-3 slide-left visible'>
                
              </div> */}
              <div className='col-lg-12 col-12 py-lg-0 py-md-0 py-2 slide-right visible text-center'>

              <h3>Expert Care, Anytime, Anywhere </h3>
                <p>Experience healthcare on your terms. Access licensed doctors instantly for personalized advice and seamless health management, wherever you are. Say goodbye to waiting rooms and rigid appointments – your health is now in your hands.</p>
              </div>
                     <div className="image-container1">
    {/* <img src={require("../../src/assets/images/website/Rectangle19.png")} className="background-image1" alt="Background" /> */}
    <img src={require("../../src/assets/images/website/Group76.webp")} className="foreground-image1" alt="Foreground" />
</div>
            </div>
          </div>
        </div>
        <div>
          </div>


            {/* <section className='pt-5'> */}
{/*            
            <div className='container-90' id='increase_revenue' style={{ marginTop: '50px' }}>
    <div className='row m-0 align-items-center'>
        <div className='col-lg-6 col-12 slide-left visible'>
            <h1>Patient Management <br/> System</h1>
        </div>
        <div className='col-lg-6 col-12'>
            <p>A Clincal Management System (CMS) is a software solution designed to streamline and enhance the administrative and clinical fuction within healthcare facilitites. It plays a crucial role in managing patient information,healthcare efficiency, ensuring regulatory compliance, and enchancing overall patient care.Here are some key components and features typically found in a  Clincal Management System.</p>
        </div>
    </div>
</div> */}
                {/* <div className=''>
                <div className='' id='increase_productivity' style={{ marginTop: '50px' }}>
    <div className='row m-0'>
        <div className='col-12'>
            <img src={require("../../src/assets/images/website/Patientmang1.png")} className='w-100 h-auto' alt="Increase Productivity" />
        </div>
    </div>
</div>
</div>
<div className='container-80 mt-5' id='increase_servicequality'>
    <div className='row m-0 align-items-center'>
        <div className='col-lg-12 col-12 slide-right visible'>
           
            <p>The patient portal is designed to manage primary and family members under the same account with unique ID for each member.Patient can access their health history,medical records, and dischrage summary and communicate with doctor and hospital anytime & anywhere. Patients Personal Identification Information (PII) and Patient Health Information (PHI) is encrypted as per  HIPAA guideline for data privacy & security</p>
            <p>KlinicQ application Patient module allows booking, rescheduling, or canceling the appointment through mobile apps to reduce no-shows & also if a patient is running late, then the system automatically provides grace time and adjusts the schedule automatically to avoid waiting in the waiting room for long time again.
            </p>
            <p>Patients can search the hospital/Clinic in our network based on various search options like Specialty of the doctor, Hospital, Gender, City, and Distance between your location and hospital. Our KlinicQ application is integrated with Google Maps so that you can view the live waiting time data in all the hospitals near your surroundings and update you with the distance to the healthcare provider's location.</p>
            <p>For pregnant women, kids, physically challenged & aged patients, waiting in the waiting room for hours is a nightmare; more crowds in the waiting room cause mental trauma & fear of getting affected by airborne disease. KlinicQ application's Token management system algorithm allocates the appointment time for each token. Visitors could arrive at the hospital just before their appointment time and use their precious time outside the waiting room instead of waiting at the waiting room, which could increase the opportunity for social distancing, and it is one of the best ways to minimize the spread of airborne disease.
            </p>
        </div>
    </div>
</div>
                <div className=''>
                <div className='container-90' id='improve_patientsatisfaction'>
    <div className='row m-0'>
        <div className='col-lg-4 col-12'>
            <img src={require("../../src/assets/images/website/Patientmang2.png")} className='w-100' alt="Benefit 1" />
        </div>
        <div className='col-lg-4 col-12'>
            <img src={require("../../src/assets/images/website/Patientmang3.png")} className='w-100' alt="Benefit 2" />
        </div>
        <div className='col-lg-4 col-12'>
            <img src={require("../../src/assets/images/website/Patientmang4.jpg")} className='w-100' alt="Benefit 3" />
        </div>
    </div>
</div>
                </div>
               
                <div className='container-80' id='increase_servicequality'>
    <div className='row m-0 align-items-center'>
        <div className='col-lg-12 col-12 slide-right visible'>
           
            <p>The KlinicQ application is user-friendly, easy to use, easy to check doctor availability with accurate wait time, and secured & confidential. KlinicQ application sends appointment confirmation texts and notifications about the follow-up appointment to the patients, reducing no-shows. </p>
            <p>The KlinicQ application has the option of online consultation through video calling, so the patients not able to go to the Hospital/Clinic can book an appointment with the available doctor for online consultation. Patients can set their favorite healthcare providers for easier appointment booking.</p>
            <p>Patient's medical records like prescriptions, discharge summaries, and vital details of their previous consultation can also be scanned or uploaded the images of all their previous medical records digitally to access anytime when required & it helps the doctor to go through all reports to provide an effective treatment.</p>
            <p>The KlinicQ application has additional features like General health tips, BMI, and vital details, and also, the payment gateway is enabled for online payments, QR code easier, and touchless check-in process. KlinicQ mobile application ( IoS and Android apps) has five different language options - English, Tamil, Hindi, Telugu, and Kannada.</p>
        </div>
    </div>
</div>
              
            </section> */}
                        <Topmove />
                        <FooterWeb className="qrCodeFooter" />
                    </div>
                    </div>
                </div>
            </div>
        );
    }
    componentDidMount = () => {
       /*  console.log(this.props.userdata.user_type);
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;

        axios
            .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
            .then((res) => {
                let data = res.data;
                console.log(res);
                console.log(data);
                console.log(data.data.timeout);
                if (data.status === "1")
                    this.setState({
                        hospitaltimeout: data.data.timeout

                    });
            })
            .catch((e) => { }); */
    }
}

export default connect(
    mapStateToProps, mapDispatchToProps
)(PatientManagment);